import { render, staticRenderFns } from "./EditPhoneNumberModal.vue?vue&type=template&id=5e27efc0&scoped=true"
import script from "./EditPhoneNumberModal.vue?vue&type=script&lang=js"
export * from "./EditPhoneNumberModal.vue?vue&type=script&lang=js"
import style0 from "./EditPhoneNumberModal.vue?vue&type=style&index=0&id=5e27efc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27efc0",
  null
  
)

export default component.exports